import { lchToRgb } from "color-converters"

export class LCH {
    lightness: number
    chroma: number
    hue: number
    #rgba: [number, number, number, number] | null = null
    #css: string | null = null
    constructor([l, c, h]: [number, number, number]) {
        this.lightness = l
        this.chroma = c
        this.hue = h
    }

    get rgba() {
        if (this.#rgba) return this.#rgba
        this.#rgba = [...lchToRgb([this.lightness, this.chroma, this.hue % 360]), 65 / 100]
        return this.#rgba
    }

    get css() {
        if (this.#css) return this.#css
        const rgba = this.rgba
        this.#css = `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`
        return this.#css
    }
}

const lchCacheMap = new Map<string, LCH>()
const limit = 50
export function lchToCSS(lch: [number, number, number]) {
    const string = lch.join(".")
    const cached = lchCacheMap.get(string)
    if (cached) return cached.css
    const lchClass = new LCH(lch)
    lchCacheMap.set(string, lchClass)

    if (lchCacheMap.size > limit) delete lchCacheMap.keys().next().value

    return lchClass.css
}
